const SMPLR_SCRIPT_URL = 'https://app.smplrspace.com/lib/smplr.js';
const SMPLR_STYLESHEET_URL = 'https://app.smplrspace.com/lib/smplr.css';

let smplrPromise;

const settleAssetLoad = (element, url, parent) =>
    new Promise((resolve) => {
        element.addEventListener('load', () => resolve({ error: null }), { once: true });
        element.addEventListener('error', () => resolve({ error: new Error(`Failed to load ${url}`) }), {
            once: true,
        });
        parent.appendChild(element);
    });

export const loadSmplr = () => {
    if (smplrPromise) return smplrPromise;
    if (window.smplr) return Promise.resolve(window.smplr);

    const script = document.createElement('script');
    script.src = SMPLR_SCRIPT_URL;
    script.async = true;

    const stylesheet = document.createElement('link');
    stylesheet.href = SMPLR_STYLESHEET_URL;
    stylesheet.rel = 'stylesheet';
    smplrPromise = Promise.all([
        settleAssetLoad(stylesheet, SMPLR_STYLESHEET_URL, document.head),
        settleAssetLoad(script, SMPLR_SCRIPT_URL, document.body),
    ])
        .then((assetResults) => {
            const failedAsset = assetResults.find(({ error }) => error);
            if (failedAsset) throw failedAsset.error;
            if (!window.smplr) throw new Error('Smplr loaded without exposing window.smplr');
            return window.smplr;
        })
        .catch((error) => {
            script.remove();
            stylesheet.remove();
            delete window.smplr;
            smplrPromise = undefined;
            throw error;
        });

    return smplrPromise;
};
